import React, {useState, useEffect} from 'react';
import {connect} from "react-redux";
import {Button, Col, Form, FormGroup, Label, UncontrolledTooltip} from 'reactstrap';
import {reduxForm} from 'redux-form';
import {toast} from "react-toastify";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestionCircle, faTimesCircle, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {uploadDocumentForInvestAccount, resetFlags, postInvestAccount} from '../../../redux/actions/AccountAction';
import UploadButton from "../../../components/UploadButton";

const AccountOwnerUploadApprovalLetter = ({
      nextStep,
      prevStep,
      handleSubmit,
      active,
      processing,
      uploadDocumentForInvestAccount,
      postInvestAccount,
      investAccount,
      secondary,
  }) => {
    const [uploadedDocs, setUploadedDocs] = useState({});
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        setUploadedDocs({});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secondary]);

    const handleNext = () => {
        toast.dismiss();
        if (!uploadedDocs['compliance_letter']) {
            toast.error('Please upload Compliance Letter');
            return;
        }
        nextStep();
    };

    const onUploadSuccess = (data) => {
        setUploading(false);
    };

    const onFileSelect = (file, fieldName) => {
        const existingFiles = uploadedDocs[fieldName] || [];
        existingFiles.push(file);
        setUploadedDocs({...uploadedDocs, [fieldName]: existingFiles});
        setUploading(true);
        const payload = {
            myra_invest_account_id: investAccount.id,
            image: file,
            is_secondary: secondary,
            document_type: fieldName
        };
        uploadDocumentForInvestAccount(payload, onUploadSuccess);
    };

    const onSkipSuccess = (data) => {
        nextStep(uploadedDocs);
    };

    const skipAndNext = () => {
        let payload = {};
        if(secondary){
            payload = {
                id: investAccount.id,
                skip: "secondary_owner_approval_letter"
            };
        } else {
            payload = {
                id: investAccount.id,
                skip: "primary_owner_approval_letter"
            };
        }
        postInvestAccount(payload, onSkipSuccess);
    };

    const clearFile = (name, index) => {
        let docs = {...uploadedDocs};
        if (docs[name]) {
            const files = docs[name];
            files.splice(index, 1);
            if (!files.length) {
                delete docs[name];
            }
        }
        setUploadedDocs(docs);
    };

    const handleBack = () => {
        prevStep();
    };

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>{secondary ? 'SECONDARY' : 'PRIMARY'} ACCOUNT OWNER</h2>
                    <span>You need an Approval Letter from your Compliance Team</span>
                </div>
                <div className="account-info-container">
                    <FormGroup row>
                        <Label sm={6} xs={7}>Compliance Letter</Label>
                        <Col sm={{size: 3, offset: 2}} xs={5}>
                            <UploadButton name="compliance_letter" onFileSelect={onFileSelect}/>
                        </Col>
                        <div sm={1} xs={1}>
                            <span id="other-doc-tooltip">
                                <FontAwesomeIcon icon={faQuestionCircle}/>
                            </span>
                            <UncontrolledTooltip innerClassName="text-left fs12" placement="right"
                                                 target="other-doc-tooltip">
                                Please upload an approval letter from Compliance department. This is required by us
                                prior to opening your account.
                            </UncontrolledTooltip>
                        </div>
                    </FormGroup>
                    {uploadedDocs['compliance_letter'] &&
                    uploadedDocs['compliance_letter'].map((fileObj, key) => {
                        return (
                            <FormGroup row key={key}>
                                <Col sm={11}>
                                    <div className="file_upload_name">
                                        <span>{fileObj.name}</span>
                                        <div className="ml-1">
                                            <FontAwesomeIcon onClick={() => clearFile('compliance_letter', key)}
                                                             icon={faTimesCircle}/>
                                        </div>
                                    </div>
                                </Col>
                            </FormGroup>
                        )
                    })
                    }

                    <FormGroup row>
                        <Label sm={6} xs={7} className="pr-sm-1 pr-0">Other (optional)</Label>
                        <Col sm={{size: 3, offset: 2}} xs={4}>
                            <UploadButton name="disclosure_other" onFileSelect={onFileSelect}/>
                        </Col>
                    </FormGroup>
                    {uploadedDocs['disclosure_other'] &&
                    uploadedDocs['disclosure_other'].map((fileObj, key) => {
                        return (
                            <FormGroup row key={key}>
                                <Col sm={11}>
                                    <div className="file_upload_name">
                                        <span>{fileObj.name}</span>
                                        <div className="ml-1">
                                            <FontAwesomeIcon onClick={() => clearFile('disclosure_other', key)}
                                                             icon={faTimesCircle}/>
                                        </div>
                                    </div>
                                </Col>
                            </FormGroup>
                        )
                    })
                    }
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="submit" disabled={processing || uploading}>
                        {uploading ? 'Uploading ' : 'NEXT STEP '}
                        {(processing || uploading) && <FontAwesomeIcon icon={faSpinner} spin/>}
                    </button>
                </div>
                <div className="links-forgot">
                    <a onClick={skipAndNext} href="#/">Don't have these documents? Upload them later.</a>
                </div>
            </Form>
        </div>
    )
};

const mapStateToProps = state => ({
    authErrors: state.Auth.errors,
    authFlags: state.Auth.flags,
    investAccount: state.Account.investAccount,
});

const mapDispatchToProps = dispatch => ({
    uploadDocumentForInvestAccount: (payload, callback) => {
        dispatch(uploadDocumentForInvestAccount(payload, callback))
    },
    postInvestAccount: (payload, callback) => {
        dispatch(postInvestAccount(payload, callback))
    },
    resetFlags: payload => {
        dispatch(resetFlags())
    }
});

const AccountOwnerUploadApprovalLetterComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountOwnerUploadApprovalLetter);

export default reduxForm({
    form: 'AccountOwnerUploadApprovalLetterForm',
})(AccountOwnerUploadApprovalLetterComponent);
